<template>
  <!--  <div id="nav">-->
  <!--    <router-link to="/">Home</router-link> |-->
  <!--    <router-link to="/about">About</router-link>-->
  <!--  </div>-->
  <router-view />
</template>

<style lang="scss">
/************************************************************
** 请将全局样式拷贝到项目的全局 CSS 文件或者当前页面的顶部 **
** 否则页面将无法正常显示                                  **
************************************************************/

html {
  font-size: 16px;
}

body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans',
    'Droid Sans', 'Helvetica Neue', 'Microsoft Yahei', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

* {
  box-sizing: border-box;
  flex-shrink: 0;
}

#app {
  width: 100vw;
  height: 100vh;
}

.m5 {
  margin: 0 5px;
}

.m2 {
  margin: 0 2px;
}

.mtb3 {
  margin: 3px 0;
}

.flex-row {
  display: flex;
  flex-direction: row;
}

.flex-col {
  display: flex;
  flex-direction: column;
}

.justify-start {
  display: flex;
  justify-content: flex-start;
}

.justify-center {
  display: flex;
  justify-content: center;
}

.justify-end {
  display: flex;
  justify-content: flex-end;
}

.justify-evenly {
  display: flex;
  justify-content: space-evenly;
}

.justify-around {
  display: flex;
  justify-content: space-around;
}

.justify-between {
  display: flex;
  justify-content: space-between;
}

.items-start {
  display: flex;
  align-items: flex-start;
}

.items-center {
  display: flex;
  align-items: center;
}

.items-end {
  display: flex;
  align-items: flex-end;
}

.width100 {
  width: 100%;
}

.van-checkbox__label {
  margin-left: 0.5rem !important;
  width: 100% !important;
}

.van-tabs__nav--line {
  box-sizing: content-box;
  height: 80% !important;
  margin: 0.2rem;
  padding-bottom: 0 !important;
}

.van-tabs__line {
  position: absolute;
  bottom: 0 !important;

}

.van-tabs--line .van-tabs__wrap {
  height: 12% !important;
}

// .van-dialog__message {
//         font-size: 21px !important;
//             color: red;
//     font-weight: 600;
//     }
.van-dialog__header {

  color: red !important;
  font-size: 21px !important;
}


.van-tabs {
  box-sizing: content-box;
  height: 100vh !important;
  padding-bottom: 5px !important;

  .van-tabs__nav--line {
    box-sizing: content-box;
    margin: 0 !important;
    padding-bottom: 0 !important;
  }

    .van-tabs__wrap {
    height: 8% !important;
  }
  .van-tab--active {
    color:#EC5A4D;
    font-weight: var(--van-font-weight-bold);
}
}</style>
